import { useTranslation } from 'react-i18next';

const featureCards = [
  {
    icon: 'ri-map-pin-2-line',
    titleKo: '최적의 위치',
    titleEn: 'Prime Location',
    desc: '동대문 패션타운, DDP, 광장시장 모두 도보권. 지하철 2·4·5호선 동대문역사문화공원역 인근.',
    img: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/49e429d203cef76e6c26ec4a25a624dc.png',
  },
  {
    icon: 'ri-hotel-bed-line',
    titleKo: '쾌적한 객실',
    titleEn: 'Comfortable Rooms',
    desc: '스탠다드·디럭스·패밀리 등 다양한 객실 타입. 전 객실 무료 와이파이, 에어컨, 냉장고 완비.',
    img: 'https://public.readdy.ai/ai/img_res/871ea7acf1b44e66e52cf304654bd96f.jpg',
  },
  {
    icon: 'ri-drop-line',
    titleKo: '사우나 시설',
    titleEn: 'Sauna Facility',
    desc: '호텔 내 사우나 시설 운영. 여행의 피로를 말끔히 풀어드립니다. 투숙객 이용 가능.',
    img: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/e8618a1c2e69d942e091facb9e030d4a.jpeg',
  },
  {
    icon: 'ri-store-2-line',
    titleKo: '쇼핑 천국',
    titleEn: 'Shopping Paradise',
    desc: '동대문 쇼핑몰(두타, 밀리오레, 현대시티아울렛) 도보 10분. 24시간 쇼핑 가능.',
    img: 'https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/11ce8a49ae978dbcc99f7fba6a39331a.jpeg',
  },
];

const About = () => {
  const { t } = useTranslation();

  return (
    <section id="about" className="py-16 md:py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">

        {/* Top: Image Grid + Text */}
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-16 mb-14 md:mb-20">
          <div className="w-full lg:w-1/2 grid grid-cols-2 gap-4">
            <div className="col-span-2 w-full h-72 overflow-hidden rounded-lg">
              <img
                src="https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/6964aa8d137ea7e13164ed12c929f6c8.jpeg"
                alt="영빈호텔 외관"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="w-full h-52 overflow-hidden rounded-lg">
              <img
                src="https://static.readdy.ai/image/8cbc9a1dc4b359b2d65998faa584ac95/12d1b63624ac5bca97d0081286725ca7.jpeg"
                alt="영빈호텔 로비"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="w-full h-52 overflow-hidden rounded-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Seoul%20Dongdaemun%20Design%20Plaza%20DDP%20at%20night%2C%20illuminated%20futuristic%20architecture%2C%20busy%20street%2C%20tourists%20walking%2C%20vibrant%20city%20atmosphere%2C%20Korea%20landmark&width=400&height=320&seq=youngbin-about-3&orientation=landscape"
                alt="동대문 DDP"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <p className="text-amber-700 text-xs tracking-[0.3em] uppercase mb-3">{t('about_tag')}</p>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-4 md:mb-6 leading-tight whitespace-pre-line" style={{ fontFamily: "'Playfair Display', serif" }}>
              {t('about_title')}
            </h2>
            <p className="text-gray-600 text-xs md:text-sm leading-relaxed mb-3">{t('about_desc1')}</p>
            <p className="text-gray-600 text-xs md:text-sm leading-relaxed mb-6 md:mb-8">{t('about_desc2')}</p>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-3 md:gap-4 mb-6 md:mb-8 p-4 md:p-6 bg-white rounded-lg border border-stone-100">
              <div className="text-center">
                <p className="text-xl md:text-2xl font-bold text-amber-700">24H</p>
                <p className="text-xs text-gray-500 mt-1 leading-tight">{t('about_stat1_label')}</p>
              </div>
              <div className="text-center border-x border-stone-100">
                <p className="text-xl md:text-2xl font-bold text-amber-700">Free</p>
                <p className="text-xs text-gray-500 mt-1 leading-tight">{t('about_stat2_label')}</p>
              </div>
              <div className="text-center">
                <p className="text-xl md:text-2xl font-bold text-amber-700">10min</p>
                <p className="text-xs text-gray-500 mt-1 leading-tight">{t('about_stat3_label')}</p>
              </div>
            </div>

            <a
              href="#reservation"
              className="inline-block px-7 md:px-8 py-2.5 md:py-3 bg-amber-700 text-white rounded-full text-sm font-medium hover:bg-amber-800 transition-colors whitespace-nowrap cursor-pointer"
            >
              {t('about_cta')}
            </a>
          </div>
        </div>

        {/* Bottom: Feature Cards */}
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {featureCards.map((feat) => (
            <div key={feat.titleEn} className="bg-white rounded-lg overflow-hidden border border-stone-100 group">
              <div className="w-full h-32 md:h-40 overflow-hidden">
                <img
                  src={feat.img}
                  alt={feat.titleKo}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-3 md:p-5">
                <div className="flex items-center gap-2 mb-1.5 md:mb-2">
                  <div className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center bg-amber-50 rounded-full">
                    <i className={`${feat.icon} text-amber-700 text-xs md:text-sm`} />
                  </div>
                  <p className="text-xs text-amber-700 font-medium hidden sm:block">{feat.titleEn}</p>
                </div>
                <h4 className="text-xs md:text-sm font-bold text-gray-900 mb-1 md:mb-2">{feat.titleKo}</h4>
                <p className="text-xs text-gray-500 leading-relaxed hidden sm:block">{feat.desc}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default About;
